import React, { useCallback } from 'react';
import { Icon } from '@sravni/react-design-system';
import { Search } from '@sravni/react-icons';
import { useStyles, useAnalytics, useBoolean } from '@sravni/react-utils';
import { SearchDialog } from './Dialog.js';
import modules_1ba53a2f from './styles/GlobalSearch.module.less.js';

// eslint-disable-next-line max-statements
const GlobalSearch = React.forwardRef((props) => {
    const { searchServiceHost, asPath, className, globalInput, ...restProps } = props;
    const cx = useStyles(modules_1ba53a2f);
    const { pushEvent } = useAnalytics();
    const [isVisible, setIsVisible] = useBoolean(false);
    const handleIconClick = useCallback(() => {
        setIsVisible.toggle();
        pushEvent({
            event: 'mainEvent',
            eventCategory: 'Поиск',
            eventAction: 'Вызов поиска',
            eventLabel: 'Место вызова - Шапка',
        });
    }, [setIsVisible, pushEvent]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { "data-qa": "GlobalSearch", className: cx(className, 'container'), ...restProps },
            React.createElement(Icon, { size: 16, className: cx('h-cursor-pointer', 'iconWrapper'), background: "dark", shape: "round", onClick: handleIconClick },
                React.createElement(Search, { className: cx('icon') }))),
        isVisible && (React.createElement(SearchDialog, { isVisible: isVisible, onClose: setIsVisible.off, searchServiceHost: searchServiceHost, asPath: asPath }))));
});
GlobalSearch.displayName = 'GlobalSearch';

export { GlobalSearch };
//# sourceMappingURL=GlobalSearch.js.map
